import * as types from './types';

export const setLayoutSettings = (data) => ({
    type: types.REQUEST_LAYOUT_SETTINGS_CHANGE,
    payload: { ...data }
});